// extracted by mini-css-extract-plugin
module.exports = {"StockStamps":"StockStamps_StockStamps__iPdb2"};